const tabs = {
  // Submit section
  start: { en: "Start", fr: "Accueil" },
  dataID: { en: "Resource Identification", fr: "Identification des ressources" },
  taxa: { en: "Taxonomic Classification", fr: "Classification Taxonomique" },
  spatial: { en: "Spatial", fr: "Spatial" },
  contacts: { en: "Contacts", fr: "Contacts" },
  resources: { en: "Data and Documentation", fr: "Données et documentation" },
  // resources: { en: "Resources", fr: "Ressources" },
  relatedworks: { en: "Related Works", fr: "Travaux connexes" },
  platform: { en: "Platform", fr: "Plateforme" },
  platformInstruments: {
    en: "Platform - instruments",
    fr: "Plateforme - instruments",
  },
  lineage: { en: "Lineage", fr: "lignée" },
};
export default tabs;
